import { publicAssetUrls } from '#public-assets'

export function isAbsoluteUrl(path: string): boolean {
    return path.startsWith('http://')
        || path.startsWith('https://')
        || path.startsWith('//')
        || path.startsWith('data:')
}

export function lookupPublicAsset(path: string): string | undefined {
    return publicAssetUrls[path.startsWith('/') ? path : `/${path}`]
}

export function publicAssetUrl(path: string): string {
    if (isAbsoluteUrl(path)) return path

    const resolved = lookupPublicAsset(path)

    if (!resolved) {
        if (import.meta.dev) {
            console.warn(`[@spilnu/core] No public asset found for ${JSON.stringify(path)}. It will be served unversioned. Restart the dev server if you just added the file.`)
        }
        return path
    }

    return resolved
}
